import TableStyles from "../../../styles/TableStyles.css";
import CommonStyles from "../../../styles/CommonStyles.css";
export const styles = (theme) => ({
  ...TableStyles,
  ...CommonStyles,

  advFieldWrap: {
    float: "left",
    width: "200px",
  },



  advActiveFilter: {
    "& input":{
      padding:"10px 25px 8px 30px !important",
    },
    "& .numberCloudField input":{
      padding:"10px 65px 10px 30px !important",
    },
    "& .numberOptionCloudField input":{
      padding:"10px 65px 10px 30px !important",
    },
    "& .MuiSelect-iconOutlined": {
      right: "23px !important",
    }, 

    "& .FilteraddMargin .MuiInputAdornment-root":{
      marginRight: "28px",
    },
    "& .FilteraddMargin input":{
      padding: "10px 10px 10px 12px !important",
    }
  },
  tableFilterOptionHasDataInput: {
    "& .MuiSelect-iconOutlined": {
      right: "63px !important"
  },
  "& .MuiSelect-outlined.MuiSelect-outlined": {
    padding: "8px 82px  8px 30px !important",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    maxWidth: "190px",
}
    },

  advanceSearchLabel: {
    fontSize: "12px",
  },
  tableFilterIcons: {
    width: "20px !important",
    display: "inline-block",
    padding: "7px 0px 9px 0px",
    minWidth: "30px",
    height: "inherit",
    paddingBottom: "0",
    marginBottom: "0",
    position: "absolute",
    left: "5px",
    top: "0",
    zIndex: " 9",
    lineHeight: "26px",
    "& span.notCondition": {
      top: "12px",
      left: "10px",
      width: "14px",
      height: "3px",
      zIndex: "9",
      position: "absolute",
      transform: "rotate(47deg)",
      background: "#ff4584",
      borderRadius: "3px",
      border: "1px solid #000000",
    },
  },
  tableColumnWrap: {
    width: "100%",
    display: "inline-block",
    position: "relative",
    background: "none",
    boxShadow: "none",
    margin: "0", 
    "&.AdvactiveFilter":{
      "& .DateRangeButton .MuiButton-text":{
        marginRight: "25px",
        marginTop: "1px",
        marginLeft: "3px"
     }
    },
    "& .MuiOutlinedInput-root": {
      maxWidth: "inherit",
    },
    "& .MuiOutlinedInput-root .MuiSelect-iconOutlined": {
      // right: "28px",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "transparent",
    },
    "& .customColorforInput.searchHighlighter .MuiInput-underline":{
      background:"#cead4a!important",
    },
    "& .customColorforInput .MuiInput-underline":{
      background:"#4c4c4c !important",
      "&:hover":{
        borderColor:" #46af22 !important",
      },
      "&:focus":{
        borderColor:" #46af22 !important",
      },
      "&:active":{
        borderColor:" #46af22 !important",
      },
      "& .MuiInputBase-input:focus":{
        borderColor:" #46af22 !important",
      }
    }
    
  },
  tableFilterInput: {
    width: "100%",
    "& input": {
      borderRadius: "4px",
      padding: "10px",
       fontSize:"0.8em",
      background: "#4A4949",
    },
    "& div": {
      borderRadius: "4px ",
      width: "100%",
    },
    "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: "#46af22 !important",
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "#46af22 !important",
      borderWidth: "1px !important",
    },
    "& label": {
      fontSize: "12px",
      top: " -10px !important",
      left: "20px",
    },
    "& .MuiInputLabel-shrink": {
      top: "2px !important",
      left: "0px",
    },
    "& .Mui-focused": {
      color: "#fff !important",
    },
  },
  tableFilterClear: {
    position: "absolute",
    right: "19px",
    top: "0",
    minWidth: "30px",
    padding: "12px 4px",
    fontSize: "11px",
    zIndex:"9"
  },
  tableFilterDate: {
    marginTop: "0",
    marginBottom: "0",
    "& input": {
      padding: "10px 10px 8px 33px !important",
    },
    "& .MuiInput-underline:after": {
      display: "none",
    },
    "& .MuiInput-underline:before": {
      display: "none",
    },
    "& .MuiInput-underline": {
      border: "1px solid rgb(76 76 76) !important",
      background: "transparent !important",
      "& button": {
        borderRadius: "5px",
      },
      "& .MuiButton-root": {
        width: "30px",
        height: "30px",
      },
      "& .MuiIconButton-root": {
        width: "30px",
        height: "30px",
      },
      "&:hover": {
        borderColor: "#46af22",
      },
      "&:focus": {
        borderColor: "#46af22",
      }
    },
    "& .Mui-focused": {
      borderColor: "#46af22",
    },
    "& .MuiInputAdornment-root": {
      width: "auto",
      marginRight: "0",
      "& svg": {
        width: "18px",
      }
    },
    "& .Mui-disabled .MuiInputAdornment-root": {
      marginRight: "23px",
    },
  },

  noDragHandle: {
    "& input": {
      borderRadius: "4px !important",
    },
    "& button": {
      right: "0",
    },
  },
  tableDataList: {
    tableLayout: "fixed",
    position: "relative",
    "& .MuiBadge-colorSecondary": {
      backgroundColor: "#f58e00",
  },
  "& tr.MuiTableRow-hover:hover": {
    cursor:"pointer",
  },
    "& td": {
      padding: "3px 10px",    
      fontSize: "0.7em",
      wordBreak: "break-word",
      overflow: "hidden",      
    },
    "& tr.MuiTableRow-hover:hover": {
       cursor:"pointer",
    },
    "& table td": {
      padding: "0px 10px !important",
      textAlign: "left",
      fontSize: "0.7em",
    },
    "& td strong": {
      // fontSize: "0.7em",
    },
    "& td:first-child": {
      background: "#000",
    },
    "& td:last-child": {
      // background: "#000",
    },
    "&  .Mui-checked svg": {
      color: "#0C853E",
    },
    "& .MuiTableRow-hover:hover": {
      backgroundColor: "rgb(76 76 76 / 62%)",
      "& td": {
        backgroundColor: "rgb(76 76 76 / 62%)",
      },
    },
    "& th": {
      padding: "0px 10px",
      textAlign: "left",
      fontSize: "0.7em",
      textTransform: "uppercase",
      fontWeight: "normal",
      whiteSpace: "nowrap",
      verticalAlign: "middle",
      "& span":{
        "&:hover":{
          "& svg":{
            display:"block",
          }
        },
        "&.MuiTableSortLabel-active":{
          "& svg":{
            display:"block",
          }
        }
      }
    },
    "& tr.tableFocusedRow .Mui-checked svg": {
      color: "#000 !important",
    },
    "& tr.tableFocusedRow":{
     "& .MuiCircularProgress-colorPrimary": {
        color:" #fff",
        width: "20px !important",
        height: "20px !important",
    }
    },
 
  },
  tableHoverRow: {
    "&:hover tr": {
      color: "yellow !important",
    },
    "& tr td": {
      border: "none !important",
    },
  },
  tableMainView: {
    // height: "100vh",
    overflow: "auto",
    // position: "absolute",
    width: "100%",
    marginTop: "0",
    background: "#000",
    position: "absolute",
    background:"none",
    //height: "calc(100% - 73px)"
    overflowX:"hidden",
    "& .MuiPaper-root":{
      background:"none",
    },
    "&.trackBusy":{
      overflow:"hidden",
      position: "relative",
      height:"100vh !important",
      "& .hideWhenLoading":{
        "& > div":{
          display:"none !important",
        }       
      },
      "& .MuiCircularProgress-colorPrimary":{
        top: "200px",
      }
    }
  },
  groupTitle:{
    display: "block !important",
    fontSize: "13px",
    margin: "10px 5px 5px 5px",
    color: "#FFC300",
    fontWeight: "bold"
  },
  groupTitleTracks:{
    marginTop:"0",
  },
  tableContainerRemoveMinheight: {
    minHeight: "inherit",
    height: "calc(100% - 44px)",
    overflow: "auto",
    position: "relative",
  },
  toolsSelect: {
    borderRadius: "4px !important",
    padding: " 0",
     fontSize:"1em",
    background: "#5d5d5d",
    verticalAlign: "top",
    margin: "0 5px",
    "& input": {
      borderRadius: "5px !important",
      padding: "8.5px 14px 8.5px 31px",
       fontSize:"1em",
    },
    "& div": {
      padding: "6px 10px",
      borderRadius: "5px !important",
      fontSize: "12px",
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "#46af22 !important",
      borderWidth: "1px!important",
    },
    "&.Mui-focused":{
      background:"#868686",
    },
    "&:hover":{
      background:"#868686",
    },
    // Added Breakpoints
    [theme.breakpoints.down("sm")]: {
      margin: "0 0px 10px 10px",
    },
    [theme.breakpoints.up("md")]: {
      margin: "0 0px 10px 10px",
    },

    [theme.breakpoints.up("lg")]: {
      margin: "0 5px 0px 5px",
    },
  },

  globalColumnInput: {
    float: "left",
    display: "flex",
    minWidth: " 250px",
    "& .MuiInput-root": {
      flexGrow: "0",
      flexShrink: "0",
      flexBasis: " 30%",
      minWidth:"auto",
    },
    "& input": {
      borderRadius: "4px !important",
      padding: "7px 27px 7px 38px",
       fontSize:"0.8em",
    },
    "& div": {
      borderRadius: "4px !important",
      width: "100%",

      // Added Breakpoints
      [theme.breakpoints.down("sm")]: {
        marginRight: "5px",
      },
      [theme.breakpoints.up("md")]: {
        marginRight: "5px",
      },

      [theme.breakpoints.up("lg")]: {
        marginRight: "5px",
      },
    },
    "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: "#46af22 !important",
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "#46af22 !important",
      borderWidth: "1px !important",
    },

    // Added Breakpoints
    [theme.breakpoints.down("sm")]: {
      minWidth: " 240px",
    },
    [theme.breakpoints.up("md")]: {
      minWidth: "348px",
      marginTop:"0px",
    },

    [theme.breakpoints.up("lg")]: {
      minWidth: "470px",
      marginTop:"0px",
    },
  },
  toolsInnerWrap: {
    background: "#4c4c4c",
    borderRadius: "5px",
    marginRight:"5px",
    float: "left",
    padding: "3px 5px",
     fontSize:"0.8em",
    width: "-webkit-fill-available",
    width:"100% ",
    "& div:before": {
        outline: "none",
        border: "none !important",
        width: "100%",
    },
    "& .MuiInput-underline:after": {
        borderBottom: "2px solid #0C853E",
    },
    "& div": {
        width: "100%",
    },
    "& input": {
        width: "100%",
        padding: "5px 8px",
         fontSize:"0.8em",
        fontWeight: "300",
    },  
},
toolsAutoSearch:{
  padding:"0px",
  "& .MuiAutocomplete-popupIndicator":{
    margin:"3px",
    padding:"0 !important",
  }, 
  "& .MuiAutocomplete-endAdornment":{
    width:"auto",
  },
  "& .MuiSvgIcon-fontSizeSmall":{
      fontSize: "1rem", 
  },    
    "& div:before": {
        outline: "none",
        border: "none !important",
        width: "100%",
    },
    "& .MuiInput-underline:after": {
        borderBottom: "none",
    },
    "& div": {
        width: "100%",
        borderRadius:"5px",
    },
    "& input": {
        width: "100%",
        padding:"8px 10px !important",
         fontSize:"13px",
        fontWeight: "300",
        background:"#3b3b3b",
    },
},
toolsAutoSearchGlobalInput:{
  "& input":{
    padding:"0px 10px 0px 22px  !important",
  }
},
toolsAutoSearchGlobal:{
  "& .DateRangeButton":{
    "& input":{
      padding:"10px 10px 8px 33px !important",
    },  
    "&  .MuiInput-underline":{
      border:"1px solid rgb(76 76 76)  !important",
    },
    "& .MuiButton-root":{
      marginTop:"2px",
      marginRight: "2px",
    }
  },
  "& .bpmBetween  .MuiFormControl-root:hover .MuiFormLabel-root":{
    top: "2px !important",
    left: "0px",
    fontSize: "12px",
    position: "absolute",
    transform: "translate(14px, -6px) scale(0.75)",
  },
  "& .bpmBetween .MuiTextField-root":{
    paddingRight: "0 !important",
  },
  "& .bpmBetween .MuiTextField-root:nth-child(2)":{
    "& label":{
      left:"0 !important",
    },
    "& .bpmBetween .MuiTextField-root:nth-child(2)":{
      "& input":{
        padding:"10px  10px 10px 10px",
      }
    }
  },
  "&.numberCloudField":{
    "& input":{
      padding:"10px  27px 10px 30px",
    },
    "& .MuiFormControl-root:nth-child(2) label":{
      left:"0px !important",
    },
  },
  "&.numberOptionCloudField":{
    "& input":{
      padding:"10px  27px 10px 30px",
    },
    "& .MuiFormControl-root:nth-child(2) label":{
      left:"0px !important",
    },
  },
  "& .MuiAutocomplete-endAdornment":{
    width:"auto",
  },
  "& .MuiAutocomplete-popupIndicator":{
    margin:"2px 3px",
    padding:"0 !important",
  },
  "& .MuiAutocomplete-inputRoot":{
    background: "#4c4c4c",
  },
  "& .MuiSvgIcon-fontSizeSmall":{
      fontSize: "1rem", 
  },    
    "& div:before": {
        outline: "none",
        border: "none !important",
        width: "100%",
    },
    "& .MuiInput-underline:after": {
        borderBottom: "none",
    },
    "& div": {
        width: "100%",
    },
    "& input": {
        width: "100%",
        padding:"10px  10px 10px 30px",
        fontSize:"0.75em",
        fontWeight: "300",
        background:"#4c4c4c",
    },
},
  toolsAddRemoveButton: {
    border: "none",
    background: "#008135",
    verticalAlign: "top",
    fontSize: "12px",
    fontWeight: "400",
    clear: "left",
    float: "left",
    textTransform: "none",
    "&:hover": {
      background: "#04923F",
      color: "#fff",
    },
    margin: "0 5px",
    padding: "5px 15px",
    minWidth: "34px",
    height: "32px",
    lineHeight: "19px",
    boxShadow: "none",
    // Added Breakpoints
    [theme.breakpoints.down("sm")]: {
      margin: "0px",
    },
    [theme.breakpoints.up("md")]: {
      margin: "0px",
    },

    [theme.breakpoints.up("lg")]: {
      margin: "0px",
    },
  },
  toolsAddRemoveButtonIcon:{
    marginLeft:"5px",
    width: "34px",
    minWidth: "inherit",
    "& .MuiButton-label":{
      width: "22px",
    }
  },
  appbarRefreshButton: {
    border: "none",
    background: "#008135",
    verticalAlign: "top",
    border: "1px solid #008135",
    "&:hover": {
      background: "#04923F",
      color: "#fff",
    },
    padding: "5px",
    minWidth: "34px",
    height: "32px",
    lineHeight: "19px",
    boxShadow: "none",
    // Added Breakpoints
    [theme.breakpoints.down("sm")]: {
      margin: "0 5px",
    },
    [theme.breakpoints.up("md")]: {
      // margin: "0 0px 0 8px",
    },

    [theme.breakpoints.up("lg")]: {
      margin: "0 5px",
    },
  },
  appbarActionButton: {
    background: "#0C853E",
    boxShadow: "none",
    color: "#fff",
    textTransform: "none",
    fontWeight: "400",
    fontSize:"0.75em",
    paddingBottom: "4px",
    paddingTop: "4px",
    paddingRight: "5px",
    border:" 1px solid #0C853E",
    "&:hover": {
      background: "#000",
      color: "#29D211",
      border:" 1px solid #0C853E",
    },
    // Added Breakpoints
    [theme.breakpoints.down("sm")]: {
      margin: "0 5px",
    },
    [theme.breakpoints.up("md")]: {
 
    },

    [theme.breakpoints.up("lg")]: {
      margin: "0px",
    },
  },
  toolsFieldWrap: {
    borderTop: "1px solid #424242",
    "&.personalSearch":{
      padding:"8px",
    },
    "& > div > div": {
      display:"inline-block",
      width: "20%",
      verticalAlign:"top",
    },
    // Added Breakpoints
    [theme.breakpoints.down("sm")]: {
      marginTop: "10px",
      // maxHeight:"200px",
      // overflow: "auto",
      overflow: "hidden",
    },
    [theme.breakpoints.up("md")]: {
      marginTop: "10px",
      // maxHeight:"200px",
      // overflow: "auto",
      overflow: "hidden",
    },

    [theme.breakpoints.up("lg")]: {
      marginTop: "10px",
      // maxHeight:"200px",
      // overflow: "auto",
      overflow: "hidden",
    },
  },
  appbarSaveSearchButton: {
    border: "none",
    background: "#008135",
    float:"left",
    verticalAlign: "top",
    "&:hover": {
        background: "#04923F",
        color: "#fff",
    },
    margin: "0 5px",
    padding: "5px",
    minWidth: "34px",
    height: "32px",
    lineHeight: "19px",
    boxShadow: "none",
// Added Breakpoints
  [theme.breakpoints.down("sm")]: {
    margin: "10px 0px 0px 10px",
  },
  [theme.breakpoints.up("md")]: {
    margin: "10px 0px 0px 10px",
  },

  [theme.breakpoints.up("lg")]: {
    margin: "10px 5px 0 5px",
  },

},

advancedSearchMainDropdown:{
  background:"#118543",
  textAlign:"left",
  margin:"0 10px 0 0 ",
  "&.Mui-focused":{
    background:"#0c6331",
  },
  "&:hover":{
    background:"#0c6331",
  },
  // Added Breakpoints
  [theme.breakpoints.down("sm")]: {
    width:"80px"
  },
  [theme.breakpoints.up("md")]: {
    width:"80px"
  },

  [theme.breakpoints.up("lg")]: {
    width:"90px"
  },
  "& div":{
    color: "#fff",
  },
  "& .MuiSelect-icon":{
    color:"#fff"
  }
},
preLoader:{
  "& .MuiCircularProgress-colorPrimary": {
    width: "20px!important",
    display: "inline-block",
    height: "20px !important",
    color: "#118543 !important",
    position: "absolute",
    top: "70px",
    left: "232px",
  }
},
advancedSearchAllDropdown:{ 
  "&.Mui-focused":{
    background:"#868686",
  },
  "&:hover":{
    background:"#868686",
  },
  // Added Breakpoints
  [theme.breakpoints.down("sm")]: {
    maxWidth: "80px",
  },
  [theme.breakpoints.up("md")]: {
    maxWidth: "160px",
  },

  [theme.breakpoints.up("lg")]: {
    maxWidth: "110px",
  },
},
toolsMainSearchWrap:{
  [theme.breakpoints.down("sm")]: {
    minWidth: "275px",
  },
  [theme.breakpoints.up("md")]: {
    minWidth: "275px",
  },

  [theme.breakpoints.up("lg")]: {
    minWidth: "430px",
  },
},
noData:{
  fontSize: "12px",
    padding: "15px 10px 8px 10px",
    display: "block",
},
circularProgress:{
  width:"20px !important",
  height:"20px !important",
  color: "green",
  margin: "10px",
  "& .MuiCircularProgress-colorPrimary":{
    color: "green", 
},
},
actionMenuIcon:{
  marginRight:"10px",
  fontSize: "18px",
},
dialogWrapper:{
  fontSize:"12px",
},
dialogYesButton:{
  background:"#118543",
  "&:hover":{
    background:"#000",
    color:"#118543",
  }
},
dialogNoButton:{
  background:"#505050",
  "&:hover":{
    background:"#000",
    color:"#fff",
  }
},
tableMainView2:{
  background:"none",
    // height: "100vh",
    overflow: "auto",
    // position: "absolute",
    width: "100%",
    marginTop: "0",
    background: "#000",
    position: "absolute",
    background:"none",
  "& .resultsForLaptop > div":{
    paddingLeft: "11.5%",
  },
  "& .MuiPaper-root":{
    background:"none",
  }
},
addPlaylistIcons:{
  fontSize:"17px !important"
},

searchButtonsSet:{
  display:"flex",
  "& > div":{
    // Added Breakpoints
  [theme.breakpoints.down("sm")]: {
    margin: "10px 5px 0px 0",
  },
  [theme.breakpoints.up("md")]: {
    //  margin: "10px 5px 0px 0",
  },

  [theme.breakpoints.up("lg")]: {
    // margin: "0 5px",
  },
  }
},
appbarAlignRight:{
  textAlign:"right",
  // Added Breakpoints
  [theme.breakpoints.down('sm')]: {
    textAlign:"left",
 
 },
 [theme.breakpoints.up('md')]: {
  textAlign:"right",
 },
 [theme.breakpoints.up('lg')]: {
  textAlign:"right",
 },
  
},

 
tagWrapMain:{
  display:"flex !important",
  maxWidth: "50%",
  "& .MuiButton-text":{
    marginTop:"10px",
  }
},
resultSettingIcon:{
    display:"flex",
    alignItems: "flex-start",
    justifyContent: "flex-end",
    "& > div > button":{
      margin:"0"
    },
    "&  > div":{
    }
},
appbarViewSettings:{
  margin:"0 8px",
  "&.Mui-focused":{
    background:"#868686",
  },
  "&:hover":{
    background:"#868686",
  },
},
dragableSpan:{ 
  cursor:"grab",
    background:"#4c4c4c",
    borderRadius: "0px 4px 4px 0px",
    bottom: "-12px",
    padding: "6px 2px 0px 2px",
    "& svg":{
      verticalAlign: "middle",
      fontSize: "10px",
    },
    "& svg path":{
      stroke:"#fff",
    }
},
globalGreenButton: {
  background: "#0C853E",
  boxShadow: "none",
  color: "#fff",
  border:"1px solid #0C853E",
  textTransform: "none",
  fontWeight: "400",
  margin: "0px 5px",
  padding:"5px 15px",
  fontSize:"12px",
  "& .MuiCircularProgress-colorPrimary":{
    width: "16px !important",
    height: "16px !important",
    marginLeft: "7px",
    color: "#fff",
  },
  "&:hover": {
      background: "#000",
      color: "#29D211",
      border:"1px solid #403f3f",
  },
},
globalGrayButton: {
background: "#545454",
boxShadow: "none",
color: "#fff",
textTransform: "none",
fontWeight: "400",
margin: "0px 0px 0px 10px",
fontSize:"12px",
"&:hover": {
    background: "#393939",
    color: "#fff",
},
},
discreteTableData:{
  width:"830px",
  maxHeight:"300px",
  overflow:"auto",
  "& td":{
    background: "#000",
  },
},
radiStationsList:{
  display:"block !important",
  "& .MuiFormControlLabel-root":{
    display:"inline-block",
    width:"30%",
  }
},
stationList:{
  display:"block",
  "& .MuiFormControlLabel-root":{
    display:"inline-block",
    verticlAlign:"top",
    width: "32%",
  }
},
trackCount:{
  position: "absolute",
    left: "20px",
},
emptyAssets:{
  color:"#9f9f9f"
},

 

});
